<template>
  <div class="rdio rdio-primary">
    <input
      :id="id"
      ref="input"
      type="radio"
      :checked="checked == value"
      :disabled="disabled"
      :value="value"
      :name="name"
      :readonly="readonly"
      @input="setValue($event.target.value)"
    >
    <label :for="id">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "radio",
  props: {
    name: String,
    disabled: Boolean,
    readonly: Boolean,
    value: {
      type: String,
      default: "1"
    },
    checked: null
  },
  data() {
    return {
      id: Math.random()
        .toString(16)
        .slice(2)
    };
  },
  methods: {
    setValue(value) {
      this.$emit("update:checked", value);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/Radio.vue